import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=70f3fc9a&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=js&"
export * from "./Divider.vue?vue&type=script&lang=js&"
import style0 from "./Divider.scss?vue&type=style&index=0&id=70f3fc9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3fc9a",
  null
  
)

export default component.exports